<template>
  <div ref="body" class="cognition-layout">
    <div class="cognition-layout__header">
      <img class="cognition-layout__bg" src="@/assets/images/login/register.png">
      <div class="cognition-layout__top">
        <img width="50px" class="logo" src="@/assets/images/login/login-white.png" />
        <span>常诚数字中台</span>
      </div>
    </div>
    <div class="cognition-layout__main">
      <div ref="content" class="cognition-layout__content" :style="{marginTop: `${marginTop}px`}">
        <router-view />
      </div>
    </div>
    <div class="cognition-layout__footer">
      <!-- <img src="@/assets/images/hongxin.png" class="register_img"/> -->
      <!-- <el-divider direction="vertical"></el-divider> -->
      <!-- <img src="@/assets/images/cict.png" class="register_img" style="margin-right:10px"/> -->
      <span>常诚数字中台</span>
    </div>
  </div>
</template>

<script>
const HEADER_HEIGHT = 56
const FOOTER_HEIGHT = 67

export default {
  data() {
    return { marginTop: HEADER_HEIGHT }
  },
  mounted() {
    this.resize()
    const observer = new MutationObserver(this.resize)
    this.$refs.content && observer.observe(this.$refs.content, { childList: true, subtree: true })
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    resize() {
      const bodyHeight = this.$refs.body.offsetHeight
      const contentHeight = this.$refs.content.offsetHeight
      // 页面高度减去header和footer高度后，剩余的高度平均分配到margin-top和margin-bottom
      // 由于header属于绝对定位，分配后的margin-top需要加上header的高度
      const marginTop = ((bodyHeight - HEADER_HEIGHT) - (contentHeight + FOOTER_HEIGHT)) / 2 + HEADER_HEIGHT
      // 不能遮挡header，所以margin-top最小值为header的高度，加10px作为留白
      this.marginTop = Math.max(marginTop, HEADER_HEIGHT + 10)
    }
  }
}
</script>

<style lang="less" scoped>
.cognition-layout {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  .cognition-layout__header {
    background-color: #0E2843;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    .logo {
      margin-right: 20px;
    }
    .cognition-layout__bg {
      width: 100%;
      min-width: 1280px;
    }
    .cognition-layout__top {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 56px;
      background-color: rgba(0, 0, 0, 0.4);
      // background-image: url(~@/assets/images/login/login-white.png);
      background-position: 16px center;
      background-repeat: no-repeat;
      display: flex;
      align-items: center;
      padding-left: 122px;
      color: #FFF;
      font-size: 24px;
    }
  }
  .cognition-layout__main {
    flex: 1;
    .cognition-layout__content {
      position: relative;
      z-index: 1;
      box-sizing: border-box;
      z-index: 100;
      background-color: #FFF;
      box-shadow: 0 0 3px rgba(54, 54, 54, 0.3);
      width: 640px;
      min-height: 500px;
      border: 1px solid @default-border-color;
      border-radius: 5px;
      padding-bottom: 20px;
      margin: 0 auto 0;
      /deep/ .cognition__content-main {
        padding-top: 32px;
        position: relative;
        .cognition__content-title {
          font-size: 28px;
          color: @label-color;
          padding-left: 160px;
          margin-bottom: 20px;
          line-height: 40px;
          height: 40px;
        }
        .el-form {
          width: 320px;
          margin: 0 auto;
        }
      }
    }
  }
  .cognition-layout__footer {
    flex: 0 0 67px;
    color: @label-color;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .register_img{
    width: 30px;
    height: 29px;
  }
}
</style>